import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.WalletsPage.KycPage.KycStepper', {
    userInformation: 'User information',
    companyInformation: 'Company information',
    accountUsage: 'Account usage',
    persons: 'Persons',
    additionalDocuments: 'Additional documents',
    submit: 'Submit',
});
